import { selectCurrentOffer } from "./selectCurrentOffer";

export const selectRate = state => {
  const currentOffer = selectCurrentOffer(state);
  return currentOffer ? currentOffer.interest_rate : null;
};
